<div ng-controller="FormConfigController as vm" class="modal-view form-config-editor" ng-mousemove="editor.onMouseMove($event)" ng-mouseup="editor.dragEnd()" ng-class="{unselectable:!!editor.dragged}">
    <div class="sidebar tools" ng-show="editor.designMode">
        <section c-form-config-tools></section>
    </div>
    <div class="sidebar properties">
        <section c-form-config-properties></section>
    </div>
    <div class="editor" ondragstart="return false;">
        <h1>{{editor.stage.Name|localize}}</h1>
        <div c-state-chart workflow-config="vm.workflowConfig" on-state-clicked="onStateClicked(state)" selected="vm.selectedState"></div>
        <div c-form-config-editor ng-click="editor.clearSelection()" id="c-form-config-editor"></div>
        <div class="dragged-element"></div>
        <div class="dragged-initial-container"></div>
    </div>
</div>
